<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} quốc tịch</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} quốc tịch</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} quốc tịch</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >          
         
          <b-row>
            <b-col md="6">
              <el-form-item label="Tên tiếng Việt" prop="ten.vi">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten.vi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Tên tiếng Anh" prop="ten.en">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten.en"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>           
            </b-col>   
          </b-row>              

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import QuocTichModel from "./QuocTichModel";
import QuocTichApi from "../../../moduleApi/QuocTichApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "QuocTich",
        dataDefault: {
          roles: DataService.rolesInForm,
                
        },
        dataForm: MethodService.copyObject(QuocTichModel.dataForm),
        validForm: QuocTichModel.validForm,
        dialog: {}        
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await QuocTichApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await QuocTichApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await QuocTichApi.findById(id);
      this.mData.dataForm = res.result;      
    },
    async fn_initDataDefault() {    

    },   

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },    
  },
  created: function() { 
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>